// Hooks
import useApi from "./useApi"

// Utils & misc
import { API_STAGES_URL } from "../../constants/constants"

const useLanguagesApi = () => {
  const [requestState, payload, error, request] = useApi()

  const getLanguages = () => {
    return request("GET", `${API_STAGES_URL}/v1/languages`)
  }

  return [
    requestState,
    payload,
    error,
    {
      getLanguages,
    },
  ]
}

export default useLanguagesApi
